// Copyright 2023 The Hanzo Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../Setting";

export function getAssets(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/v1/assets?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getAsset(owner, name) {
  return fetch(`${Setting.ServerUrl}/v1/assets/${owner}/${encodeURIComponent(name)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function updateAsset(owner, name, asset) {
  const newAsset = Setting.deepCopy(asset);
  return fetch(`${Setting.ServerUrl}/v1/assets/${owner}/${encodeURIComponent(name)}`, {
    method: "PUT",
    credentials: "include",
    body: JSON.stringify(newAsset),
  }).then(res => res.json());
}

export function addAsset(asset) {
  const newAsset = Setting.deepCopy(asset);
  return fetch(`${Setting.ServerUrl}/v1/assets`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newAsset),
  }).then(res => res.json());
}

export function deleteAsset(asset) {
  return fetch(`${Setting.ServerUrl}/v1/assets/${asset.owner}/${encodeURIComponent(asset.name)}`, {
    method: "DELETE",
    credentials: "include",
  }).then(res => res.json());
}
